import { render } from "./EditRoleClient.vue?vue&type=template&id=30b5463b"
import script from "./EditRoleClient.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRoleClient.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/EditRoleClient.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30b5463b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30b5463b', __exports__)) {
    api.reload('30b5463b', __exports__)
  }
  
  module.hot.accept("./EditRoleClient.vue?vue&type=template&id=30b5463b", () => {
    api.rerender('30b5463b', render)
  })

}


export default __exports__